import React, { Component, type AbstractComponent } from 'react'
import ReactAnimationFrame from 'react-animation-frame'
import { styled } from 'styled-components'

type Props = {}

class Static extends Component<Props> {
	canvas: any

	canvasContext: any
	imageData: any
	imageBuffer: any

	constructor(props) {
		super(props)

		this.canvas = React.createRef()

		this.canvasContext = null
		this.imageData = null
		this.imageBuffer = null
	}

	componentDidMount() {
		if (this.canvas.current) {
			const canvas = this.canvas.current

			this.canvasContext = canvas.getContext('2d', { alpha: false })
			this.imageData = this.canvasContext.createImageData(
				canvas.width,
				canvas.height
			)
			this.imageBuffer = new Uint32Array(this.imageData.data.buffer)
		}
	}

	onAnimationFrame = () => {
		/* eslint-disable */
		if (!this.canvasContext || !this.imageData || !this.imageBuffer) {
			return
		}

		let len = this.imageBuffer.length - 1

		while (len--) {
			this.imageBuffer[len] = Math.random() < 0.5 ? 0 : -1 >> 0
		}

		this.canvasContext.putImageData(this.imageData, 0, 0)
	}

	render() {
		return <StyledCanvas ref={this.canvas} width={200} height={200} />
	}
}

const StyledCanvas = styled.canvas`
	position: absolute;
	opacity: 0.08;
	width: 100%;
	height: 100%;
	z-index: ${({ theme }) => theme.zAlwaysShow};
`

export default (ReactAnimationFrame(Static, 100): AbstractComponent<Props>)
